import { Helmet } from 'react-helmet';
import RootProvider from './providers';
import { Router } from './router';
import './scss/global.scss';
import './utils/polyfills'

function App() {
  return (
    <>
      <Helmet />
      <RootProvider>
        <Router />
      </RootProvider>
    </>
  );
}

export default App;
